var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: "添加学生",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "popover", staticStyle: { "flex-direction": "column" } },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "margin-bottom": "10px",
                position: "relative"
              }
            },
            [
              _c("el-input", {
                staticStyle: { width: "25% !important" },
                attrs: { clearable: "", placeholder: "学生名称" },
                model: {
                  value: _vm.paramsData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "name", $$v)
                  },
                  expression: "paramsData.name"
                }
              }),
              _c("el-input", {
                staticStyle: { width: "25% !important", "margin-left": "10px" },
                attrs: { clearable: "", placeholder: "账号" },
                model: {
                  value: _vm.paramsData.account,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "account", $$v)
                  },
                  expression: "paramsData.account"
                }
              }),
              _c(
                "el-col",
                { staticStyle: { "margin-left": "10px" }, attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.reqLoading },
                      on: {
                        click: function($event) {
                          return _vm.getList(1)
                        }
                      }
                    },
                    [_vm._v("搜索")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "25%", "margin-bottom": "10px" },
              attrs: {
                clearable: "",
                filterable: "",
                placeholder: "请选择奖励分组"
              },
              model: {
                value: _vm.reward_tier_id,
                callback: function($$v) {
                  _vm.reward_tier_id = $$v
                },
                expression: "reward_tier_id"
              }
            },
            _vm._l(_vm.rewardList, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id }
              })
            }),
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.reqLoading,
                  expression: "reqLoading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  width: "60px",
                  type: "selection"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "学生姓名", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "school", label: "学校", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "电话", align: "center" }
              }),
              _c("el-table-column", {
                attrs: { prop: "id_card", label: "身份证", align: "center" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                round: "",
                disabled: !_vm.student_ids.length
              },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }